'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CaseStudyQuote } from '@/components/case-study/case-study-quote';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const SnelEenTaxiCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="Snel Een Taxi"
        title={t.customerStories['sneleentaxi_hero_title']}
        subtitle={t.customerStories['sneleentaxi_what_we_did']}
        stats={[
          {
            value: isRTL ? '+٧٥٪' : '75%+',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? '+٦ آلاف' : '6K+',
            label: t.customerStories['Drivers nationwide'],
          },
          {
            value: isRTL ? '+٥٠٠ ألف' : '500K+',
            label: t.customerStories['Customers served'],
          },
        ]}
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-sneleentaxi.svg',
          logoAlt: 'Snel Een Taxi',
          company: t.customerStories['sneleentaxi_company_description'],
          industry: t.customerStories['Transportation / Ride-Hailing'],
          websiteUrl: 'https://www.sneleentaxi.nl',
          keyResults: [
            t.customerStories['• 75%+ automation rate'],
            t.customerStories['• 6,000+ drivers supported'],
            t.customerStories['• 24/7 Dutch support'],
            t.customerStories['• Nationwide coverage'],
          ],
        }}
      >
        <p>{t.customerStories['sneleentaxi_intro']}</p>

        <h2>{t.customerStories['sneleentaxi_competing_title']}</h2>
        <p>{t.customerStories['sneleentaxi_competing_p1']}</p>
        <p>{t.customerStories['sneleentaxi_competing_p2']}</p>

        <h2>{t.customerStories['sneleentaxi_solution_title']}</h2>
        <p>{t.customerStories['sneleentaxi_solution_p1']}</p>
        <p>{t.customerStories['sneleentaxi_solution_p2']}</p>
        <p>{t.customerStories['sneleentaxi_solution_p3']}</p>

        <h2>{t.customerStories['sneleentaxi_scaling_title']}</h2>
        <p>{t.customerStories['sneleentaxi_scaling_intro']}</p>
        <ul>
          <li>
            <strong>{t.customerStories['Customer Support']}</strong>{' '}
            {t.customerStories['sneleentaxi_scaling_customer']}
          </li>
          <li>
            <strong>{t.customerStories['Driver Support']}</strong>{' '}
            {t.customerStories['sneleentaxi_scaling_driver']}
          </li>
          <li>
            <strong>{t.customerStories['Healthcare Transport']}</strong>{' '}
            {t.customerStories['sneleentaxi_scaling_healthcare']}
          </li>
        </ul>
        <p>{t.customerStories['sneleentaxi_scaling_escalation']}</p>

        <CaseStudyQuote
          quote={[
            t.customerStories['sneleentaxi_quote_p1'],
            t.customerStories['sneleentaxi_quote_p2'],
            t.customerStories['sneleentaxi_quote_p3'],
          ]}
          attribution={t.customerStories['sneleentaxi_quote_attribution']}
        />

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['sneleentaxi_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '+٧٥٪' : '75%+',
            },
            {
              metric: t.customerStories['Response time'],
              impact: t.customerStories['Under 30 seconds'],
            },
            {
              metric: t.customerStories['Driver network'],
              impact: t.customerStories['6,000+ supported'],
            },
            {
              metric: t.customerStories['Coverage'],
              impact: t.customerStories['24/7 in Dutch'],
            },
          ]}
        />

        <h2>{t.customerStories['sneleentaxi_impact_title']}</h2>
        <p>{t.customerStories['sneleentaxi_impact_p1']}</p>
        <p>{t.customerStories['sneleentaxi_impact_p2']}</p>
        <p>{t.customerStories['sneleentaxi_impact_p3']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default SnelEenTaxiCaseStudy;
